export { default } from './TermsModal';
